document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('quantity-input.quantity').forEach(function (qtyInput) {
    if (qtyInput.dataset.a24Digits === 'true') return;
    qtyInput.dataset.a24Digits = 'true';

    var input = qtyInput.querySelector('.quantity__input');
    if (!input) return;

    var min = parseInt(input.min || input.dataset.min || '1', 10);
    var max = parseInt(input.max || input.dataset.max || '9', 10);
    if (isNaN(min) || min < 1) min = 1;
    if (isNaN(max) || max > 9) max = 9;

    var wrapper = document.createElement('div');
    wrapper.className = 'quantity__digits';

    var buildDigits = function () {
      wrapper.innerHTML = '';
      for (var i = min; i <= max; i++) {
        (function (value) {
          var digit = document.createElement('button');
          digit.type = 'button';
          digit.className = 'quantity__digit';
          digit.textContent = value;
          if (parseInt(input.value, 10) === value) {
            digit.classList.add('quantity__digit--selected');
          }
          digit.addEventListener('click', function () {
            wrapper.querySelectorAll('.quantity__digit').forEach(function (d) {
              d.classList.remove('quantity__digit--selected');
            });
            digit.classList.add('quantity__digit--selected');
            input.value = value;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
          wrapper.appendChild(digit);
        })(i);
      }
    };

    buildDigits();
    qtyInput.insertAdjacentElement('afterend', wrapper);
    qtyInput.classList.add('quantity--a24-hidden');
  });
});